import React from "react";
import { toast } from "react-toastify";

import capitalizeFirstLetter from "@helpers/capitalizeFirstLetter";
import ICopy from "assets/svgs/i-copy.js";

function MarketingAgent({ data }) {
  const { name, company, userImage, id, license_user } = data;
  const handleCopy = () => {
    navigator.clipboard.writeText(license_user);
    toast.success("License user copied to clipboard");
  };
  return (
    <div>
      <div className="marketing-agent-card-wrapper">
        <div className="info-image-wrapper">
          <div className="marketing-agent-info">
            <p className="header-marketing-agent">Marketing</p>
            <a
              href={`/${capitalizeFirstLetter(name.split(" ").join("-"))}?id=${id}`}
              className="name"
            >
              {name}
            </a>
            <p className="company">Century 21 {company}</p>
          </div>

          <div className="marketing-agent-image">
            <img className="image" src={userImage} alt="foto marketing agent" />
          </div>
        </div>
      </div>

      {license_user && (
        <div
          onClick={handleCopy}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            justifyContent: "space-between",
            borderBottom: "1px solid #DEDFDE",
            padding: "0 24px",
            marginBottom: "8px",
            cursor: "pointer",
          }}
        >
          <div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                borderRadius: "2px",
                background:
                  "linear-gradient(90deg, rgba(235, 240, 247, 0.00) 0%, #EBF0F7 100%)",
                width: "fit-content",
                padding: "2px 8px 2px 2px",
                marginBottom: "4px",
              }}
            >
              <img
                style={{ width: "16px", height: "16px" }}
                src="/static/images/icon-verifued.png"
                alt="verified"
              />
              <p
                style={{
                  margin: 0,
                  fontSize: "14px",
                  fontFamily: "SF Pro Display",
                }}
              >
                No. Reg.{" "}
                <span style={{ fontFamily: "SF Pro Display SemiBold" }}>
                  {license_user}
                </span>
              </p>
            </div>

            <p
              style={{
                margin: 0,
                fontSize: "11px",
                fontFamily: "SF Pro Display",
                color: "#7B7B7B",
              }}
            >
              Tenaga Pemasar Properti Tersertifikasi oleh BNSP
            </p>
          </div>

          <ICopy />
        </div>
      )}
    </div>
  );
}

export default MarketingAgent;
